import { Grid } from '@mui/material';
import { useOutlet } from 'react-router';
import { usePageTitle } from '@hooks/usePageTitle';
import { Header } from '@layouts/Base/components/Header';
import { VacanciesTable } from '@area/vacancies/components/VacanciesTable';

export const VacanciesPage = () => {
  usePageTitle('Вакансии');

  const outlet = useOutlet();

  if (outlet) {
    return outlet;
  }

  return (
    <Grid container direction="column" gap="24px">
      <Grid item>
        <Header title="Вакансии" />
      </Grid>
      <VacanciesTable />
    </Grid>
  );
};
